import { EnvMicroMessaging } from 'lib-klab-core';

export const envKlabMessagingLocal: EnvMicroMessaging = {
    host: 'http://localhost:3000',
    apiBasePath: '',
    wsNamespace: '/v1/chat',
};

export const envKlabMessagingDev: EnvMicroMessaging = {
    host: 'https://gatewayapi-dev.klab.inclub.world',
    apiBasePath: '/ms-messaging-ws',
    wsNamespace: '/v1/chat',
};

export const envKlabMessagingProd: EnvMicroMessaging = {
    host: 'https://gatewayapi.klab.inclub.world',
    apiBasePath: '/ms-messaging-ws',
    wsNamespace: '/v1/chat',
};
